import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for fetching carousel data from API
export const fetchCarouselData = createAsyncThunk(
  'frontPage/fetchCarouselData',
  async () => {
    const response = await fetch('/api/carousel');
    return response.json();
  }
);

const frontPageSlice_20 = createSlice({
  name: 'frontPage',
  initialState: {
    slides: [
      {
        id: 1,
        color: "#007bff",
        image: "/pimages/img_axl/01_carousel/600_q5.png",
        title: "Amsterdam 2025 Highlights",
        description:
          "Discover next-generation OCXO solutions at the exhibition.",
        cta: "Learn More",
      },
      {
        id: 2,
        color: "#ff5733",
        image: "/pimages/img_axl/01_carousel/600_q10.png",
        title: "Precision Timing Everywhere",
        description:
          "Stable frequency for drones, sensors, radars, and modern communication systems.",
        cta: "Get Started",
      },
      {
        id: 3,
        color: "#28a745",
        image: "/pimages/img_axl/01_carousel/600_q15.png",
        title: "Compact Size. Serious Stability.",
        description:
          "From CSAC to mini-OCXO — precision timing in every form factor.",
        cta: "Explore Now",
      },
      {
        id: 4,
        color: "#28a745",
        image: "/pimages/img_axl/01_carousel/600_q20.png",
        title: "Reliable Timing at Sea",
        description:
          "Keeping distributed marine systems and tracking networks in sync.",
        cta: "Explore Now",
      },
    ],
    currentSlide: 0,
    isMenuOpen: false,
    loading: false,
    error: null,
  },
  reducers: {
    setCurrentSlide: (state, action) => {
      state.currentSlide = action.payload;
    },
    nextSlide: (state) => {
      state.currentSlide = (state.currentSlide + 1) % state.slides.length;
    },
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    closeMenu: (state) => {
      state.isMenuOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCarouselData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCarouselData.fulfilled, (state, action) => {
        state.loading = false;
        state.slides = action.payload;
      })
      .addCase(fetchCarouselData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setCurrentSlide, nextSlide, toggleMenu, closeMenu } = frontPageSlice_20.actions;
export default frontPageSlice_20.reducer;